/** Fields that get autocomplete suggestions (localStorage + loaded rows). */
export const CAR_RENTAL_SUGGESTION_FIELDS = [
  'project',
  'userName',
  'regNumber',
  'rentalCompany',
  'poNumber',
  'invoiceNumber'
];

const STORAGE_KEY = 'striitsmart:carRentalSuggestions';
const MAX_PER_FIELD = 200;

const emptyStore = () =>
  Object.fromEntries(CAR_RENTAL_SUGGESTION_FIELDS.map((f) => [f, []]));

export const loadCarRentalSuggestions = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return emptyStore();
    const parsed = JSON.parse(raw);
    const store = emptyStore();
    CAR_RENTAL_SUGGESTION_FIELDS.forEach((field) => {
      const list = parsed?.[field];
      store[field] = Array.isArray(list)
        ? [...new Set(list.map((v) => String(v).trim()).filter(Boolean))].sort((a, b) =>
            a.localeCompare(b, undefined, { sensitivity: 'base' })
          )
        : [];
    });
    return store;
  } catch {
    return emptyStore();
  }
};

export const saveCarRentalSuggestions = (store) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    /* quota / private mode */
  }
};

export const mergeSuggestionsFromRows = (store, rows) => {
  const next = { ...store };
  CAR_RENTAL_SUGGESTION_FIELDS.forEach((field) => {
    const set = new Set(next[field] || []);
    (rows || []).forEach((row) => {
      const v = String(row[field] ?? '').trim();
      if (v) set.add(v);
    });
    next[field] = Array.from(set).sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: 'base' })
    );
  });
  return next;
};

export const rememberCarRentalField = (field, value) => {
  const v = String(value ?? '').trim();
  if (!v || !CAR_RENTAL_SUGGESTION_FIELDS.includes(field)) return;
  const store = loadCarRentalSuggestions();
  const set = new Set(store[field] || []);
  set.add(v);
  store[field] = Array.from(set)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
    .slice(0, MAX_PER_FIELD);
  saveCarRentalSuggestions(store);
  return store;
};

export const rememberCarRentalRow = (row) => {
  if (!row) return loadCarRentalSuggestions();
  let store = loadCarRentalSuggestions();
  CAR_RENTAL_SUGGESTION_FIELDS.forEach((field) => {
    const v = String(row[field] ?? '').trim();
    if (!v) return;
    const set = new Set(store[field] || []);
    set.add(v);
    store[field] = Array.from(set)
      .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
      .slice(0, MAX_PER_FIELD);
  });
  saveCarRentalSuggestions(store);
  return store;
};
